<div *ngIf="cropReady" class="actions">
  <div class="action-buttons">

    <button mat-icon-button style="float: left;" (click)="cancel()">
      <mat-icon>reply</mat-icon>
    </button>

    <button mat-icon-button (click)="zoom_out()">
      <mat-icon>zoom_out</mat-icon>
    </button>

    <button mat-icon-button (click)="zoom_in()">
      <mat-icon>zoom_in</mat-icon>
    </button>

    <button mat-icon-button (click)="cropper.rotate(-45)">
      <mat-icon>rotate_left</mat-icon>
    </button>

    <button mat-icon-button (click)="cropper.rotate(45)">
      <mat-icon>rotate_right</mat-icon>
    </button>

    <button mat-icon-button style="float: right;" (click)="save()">
      <mat-icon>check</mat-icon>
    </button>

  </div>
</div>
<div class="img-container rounded">
  <ng-container>
    <img #imageCropper [src]="sourceImage" crossorigin>
  </ng-container>

</div>
<div *ngIf="cropReady" class="result-box">
  <img class="destination-image" [src]="imageDestination">
</div>
<!-- Add image Button -->
<input style="display: none" type="file" accept="image/*" (change)="onFileChanged($event)" #fileInput>
<div *ngIf="!cropReady" class="loader">
  <div class="cancel-actions">
    <button mat-icon-button class="cancel-action" (click)="cancel()">
      <mat-icon>clear</mat-icon>
    </button>
  </div>
  <gio-loading-page subtitle="carregando imagem..."></gio-loading-page>

</div>
